import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const twoFactorAuthTemplate = htmlE`
    <style>
      #twoFactorAuthQrCodeContainer {
        grid-gap: 8px;
      }

      #twoFactorAuthQrCode {
        display: block;
        height: 235px;
        margin: auto;
        background-color: white;
      }
    </style>
    <div class="px-5">
        ${({ showHeader }) => {
          if (showHeader) {
            return `<p class="has-text-centered">Please setup 2 factor auth to continue
                <a class="text-primaryMain text-sm is-underlined" target="_blank" href="https://www.crushftp.com/crush11wiki/Wiki.jsp?page=Authenticator">Learn More</a></p>`;
          }
        }}

      <div class="mb-5 content">
        <ul>
          <li class="text-primaryMain text-sm"> Download & install the Authenticator App on smartphone </li>
          <li class="text-primaryMain text-sm"> Click on Setup button below, it will generate a QR </li>
          <li class="text-primaryMain text-sm"> Start the Authenticator App and use "Scan a QR code" function to register </li>
        </ul>
        <a class="text-primaryMain text-sm is-underlined" target="_blank" href="https://www.crushftp.com/crush11wiki/Wiki.jsp?page=Authenticator">Learn More</a>
      </div>

      <button data-i18n-key="readyToScan" id="twoFactorAuthSetupButton" style="margin:auto;" class="btn primary-button">Ready to Scan</button>

      <div class="is-flex is-align-items-center is-justify-content-center is-hidden is-flex-direction-column" id="twoFactorAuthQrCodeContainer">
        <img id="twoFactorAuthQrCode"></img>
        <p id="twoFactorAuthUpdateQRText" class="w-full has-text-centered text-sm is-hidden">The QR Code will be refreshed in <span id="twoFactorAuthQrCountDownValue">30</span> seconds Or <u class="is-cursor-pointer" data-i18n-key="clickHereToGenerateANewOne" id="resetQR">clickHereToGenerateANewOne</u></p>
      </div>
    </div>`;
